import { render } from "./FileExplorerElementIcon.vue?vue&type=template&id=e877e042&scoped=true"
import script from "./FileExplorerElementIcon.vue?vue&type=script&lang=js"
export * from "./FileExplorerElementIcon.vue?vue&type=script&lang=js"

import "./FileExplorerElementIcon.vue?vue&type=style&index=0&id=e877e042&scoped=true&lang=scss"

import exportComponent from "/tmp/b45e941b-d1ac-4235-8dba-072c0c886010/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e877e042"]])

export default __exports__